export default "__VITE_ASSET__DcsrnGu$__"